import React from "react"
import { OldButton } from "@kit/design/old-button"
import Label from "@kit/design/label"
import Stack from "@kit/design/stack"
import Grid from "@kit/design/grid"
import { RadioButtonGroup, handleDelete } from "../setting-utils"
import { useBlocks } from "../../hooks/use-blocks"
import {
  CropPortrait,
  CropLandscape,
  CropSquare,
  CropNone
} from "app/forms/elements/gallery/gallery-icons"
import "./gallery-settings.css"

export function GallerySettings({ block_id, properties }) {
  const { update, remove } = useBlocks(block_id)

  const handleChange = event => {
    update({ [event.target.name]: event.target.value })
  }

  const removeGallery = () => {
    handleDelete(block_id, remove, "gallery")
  }

  return (
    <div className="px-4 pb-4">
      <Stack spacing={4}>
        <Stack spacing={2}>
          <Label>Rounded Corners</Label>
          <RadioButtonGroup
            name="radius"
            onChange={handleChange}
            value={properties.radius}
            options={[
              { label: "None", value: 0 },
              { label: "Small", value: 6 },
              { label: "Large", value: 16 }
            ]}
          />
        </Stack>
        <Stack spacing={1}>
          <Grid columns="repeat(auto-fit, minmax(100px, 1fr))" gap="1rem">
            <div className="">
              <Label>Columns</Label>
              <RadioButtonGroup
                name="columns"
                onChange={handleChange}
                value={properties.columns}
                options={[
                  { label: "1", value: 1 },
                  { label: "2", value: 2 }
                ]}
              />
            </div>
            <div>
              <Label>Crop</Label>
              <RadioButtonGroup
                name="crop"
                onChange={handleChange}
                value={properties.crop}
                options={[
                  {
                    value: "landscape",
                    "aria-label": "landscape",
                    icon: <CropLandscape />
                  },
                  {
                    value: "portrait",
                    "aria-label": "portrait",
                    icon: <CropPortrait />
                  },
                  {
                    value: "square",
                    "aria-label": "square",
                    icon: <CropSquare />
                  },
                  {
                    value: "none",
                    "aria-label": "No cropping",
                    icon: <CropNone />
                  }
                ]}
              />
            </div>
          </Grid>
        </Stack>

        <OldButton
          size="sm"
          is="secondary"
          className="ml-auto block"
          onClick={removeGallery}
          icon="delete"
        >
          Remove gallery
        </OldButton>
      </Stack>
    </div>
  )
}
